"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 27.8 25",
    width: "27.8",
    height: "25"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M7.2,21.2c-0.3,0-0.5-0.2-0.5-0.5V5.3C6.7,5,7,4.8,7.2,4.8S7.7,5,7.7,5.3v15.4C7.7,21,7.5,21.2,7.2,21.2z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M14,10.6c-0.3,0-0.5-0.2-0.5-0.5V0.5C13.5,0.2,13.7,0,14,0s0.5,0.2,0.5,0.5v9.6C14.5,10.4,14.3,10.6,14,10.6z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M7.2,21.2c-0.1,0-0.2,0-0.3-0.1l-6.7-4.8C0.1,16.2,0,16.1,0,15.9V0.5c0-0.2,0.1-0.4,0.3-0.4C0.4,0,0.6,0,0.8,0.1l6.5,4.6 l6.5-4.6c0.2-0.1,0.4-0.1,0.6,0L21,4.9c0.1,0.1,0.2,0.2,0.2,0.4v4.8c0,0.3-0.2,0.5-0.5,0.5s-0.5-0.2-0.5-0.5V5.6L14,1.1L7.5,5.7 C7.4,5.9,7.1,5.9,7,5.7L1,1.5v14.2l6.2,4.5l5.5-3.9c0.2-0.2,0.5-0.1,0.7,0.1c0.2,0.2,0.1,0.5-0.1,0.7l-5.8,4.1 C7.5,21.2,7.3,21.2,7.2,21.2z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M18.8,23.2c-0.1,0-0.3-0.1-0.4-0.2c-0.4-0.5-4-4.8-4-7.1c0-2.4,2-4.4,4.4-4.4s4.4,2,4.4,4.4c0,2.2-3.6,6.6-4,7.1 C19.1,23.1,19,23.2,18.8,23.2z M18.8,12.6c-1.9,0-3.4,1.5-3.4,3.4c0,1.4,2.2,4.4,3.4,6c1.2-1.5,3.4-4.5,3.4-6 C22.2,14.1,20.7,12.6,18.8,12.6z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M18.8,17.9c-1.1,0-1.9-0.9-1.9-1.9s0.9-1.9,1.9-1.9s1.9,0.9,1.9,1.9S19.9,17.9,18.8,17.9z M18.8,15 c-0.5,0-0.9,0.4-0.9,0.9s0.4,0.9,0.9,0.9s0.9-0.4,0.9-0.9S19.3,15,18.8,15z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M19,25c-3.3,0-8.9-0.5-8.9-2.4c0-1.4,2.8-2,5.1-2.2c0.3,0,0.5,0.2,0.6,0.4c0,0.3-0.2,0.5-0.4,0.6c-3,0.3-4.2,1-4.2,1.2 c0.1,0.5,3,1.4,7.9,1.4c4.9,0,7.7-0.9,7.9-1.4c-0.1-0.2-1.2-0.9-4.3-1.2c-0.3,0-0.5-0.3-0.4-0.6c0-0.3,0.3-0.5,0.6-0.4 c2.4,0.3,5.2,0.9,5.2,2.2C27.8,24.5,22.3,25,19,25z"
  }));
};

exports["default"] = _default;